const GENDER = {
    MALE:'male',
    FEMALE: 'female',
    OTHER: 'other'
}

const PRESET_PASSWORD = {
    ANALYTIC_AND_REPORTING_PASSWORD:'12345',
    BILLING_PASSWORD:'12345'
}

const USER_ROLE_DEFAULT = {
    ADMIN:"admin",
    PATIENT: "Patient",
    EXTERNAL_REFERRER: "externalReferrer",
    CLERICAL_STAFF: "clericalStaff"
}

const USER_ROLE = [
    {
        role: "admin",
        displayText: "Admin"
    },
    {
        role: "externalReferrer",
        displayText: "External User"
    },
    {
        role: "clericalStaff",
        displayText: "Clerical Staff"
    },
    {
        role: "phlebotomist",
        displayText: "Phlebotomist"
    },
    {
        role: "labTechnician",
        displayText: "Lab Technician"
    },
    {
        role: "labTechnologist",
        displayText: "Lab Technologist"
    },
    {
        role: "labSupervisor",
        displayText: "Lab Supervisor"
    },
    {
        role: "pathologist",
        displayText: "Pathologist"
    },
    {
        role: "labDirector",
        displayText: "Lab Director"
    },
    {
        role: "labAdmin",
        displayText: "Lab Administrator"
    },
]

const APPOINTMENT_CATEGORIES = {
    SCHEDULED:'Scheduled',
    WALKIN: 'Walk-In',
}

// Guyana census descent categories — used for the health-voucher "User
// Ethnicity" column, and offered as an optional field wherever a patient is
// registered (full registration form, and the lab orders quick-register dialog).
const ETHNICITY_OPTIONS = [
    'Guyanese of Indian Descent',
    'Guyanese of African Descent',
    'Guyanese of Amerindian Descent',
    'Guyanese of Mixed Descent',
    'Guyanese of Chinese Descent',
    'Guyanese of Portuguese Descent',
    'Guyanese of European Descent',
    'Other',
];

const COUNTRIES = [
    "Guyana",
    "Suriname",
    "Trinidad and Tobago",
    "Barbados",
    "Jamaica",
    "Bahamas",
    "Haiti",
    "Dominican Republic",
    "Cuba",
    "Puerto Rico",
    "United States",
    "Canada",
    "United Kingdom",
    "Brazil",
    "Venezuela",
    "Colombia",
    "Argentina",
    "Chile",
    "Peru",
    "Mexico",
    "France",
    "Germany",
    "Spain",
    "Italy",
    "Netherlands",
    "Portugal",
    "India",
    "China",
    "Japan",
    "Australia",
    "New Zealand",
    "South Africa",
    "Nigeria",
    "Ghana",
    "Kenya",
    "Other"
];

export {
    USER_ROLE_DEFAULT,
    GENDER,
    PRESET_PASSWORD,
    USER_ROLE,
    APPOINTMENT_CATEGORIES,
    COUNTRIES,
    ETHNICITY_OPTIONS
}